export default __webpack_public_path__ + "static/media/way to reception arealabel.dfca8164.png";